export default "__VITE_ASSET__f69e51c5__"